<template>
    <CardPage :section="2" :page="8" :nextDisabled="nextDisabled" ref="cardPage">
        <p class="font-weight-bold" v-if="currentQuizItem">
            <v-fade-transition mode="out-in">
                <span :key="currentQuizItem.question">{{ currentQuizItem.question }}</span>
            </v-fade-transition>
        </p>
        <p v-else class="font-weight-bold font-italic">You've matched all the legends!</p>
        <v-container fluid grid-list-xs>
            <v-layout row wrap justify-center>
                <v-flex v-for="(key, index) in quizOrder" :key="index" xs6 class="answer">
                    <a @click.prevent="click(quiz[key])">
                        <ResponsiveImage
                            v-ripple
                            :src="quiz[key].image"
                            :class="{ correct: quiz[key].correct }"
                            layout=""
                            flex=""
                            :alt="quiz[key].name"
                        ></ResponsiveImage>
                    </a>
                    <div class="check" v-if="quiz[key].correct">
                        <v-avatar class="success">
                            <v-icon dark>check</v-icon>
                        </v-avatar>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        quiz: get('section2/quiz'),
        quizOrder: get('section2/quizOrder'),
        currentQuizItem: get('section2/currentQuizItem')
    },
    methods: {
        click(quizItem) {
            if (!this.currentQuizItem) {
                return;
            }

            if (this.currentQuizItem.name === quizItem.name) {
                this.$refs.modalFeedback.show(true, 'Good job!', () => {
                    this.$store.set(`section2/quiz@${quizItem.id}.correct`, true);
                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Close! Try again.');
            }
        },
        nextDisabled() {
            return !!this.currentQuizItem;
        }
    }
};
</script>

<style scoped>
.answer {
    position: relative;
}
.check {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(-25%, -25%);
}
.correct {
    opacity: 0.5;
}
</style>
